import React from 'react';
import { ILaborOverride } from 'types';
import { OverrideReasonBox, OverrideReasonBy, OverrideReasonLabel, OverrideReasonText } from './styles';
import { formatOverriddenBy } from './utils';

interface IOverrideReasonCalloutProps {
  overridden?: ILaborOverride;
  label: string;
}

// Who made the labor's current manual correction, when, and why. Renders nothing when the labor isn't overridden.
export const OverrideReasonCallout: React.FC<IOverrideReasonCalloutProps> = ({ overridden, label }) => {
  if (!overridden?.reason) return null;

  return (
    <OverrideReasonBox>
      <OverrideReasonLabel data-cy="current-override-label">{label}</OverrideReasonLabel>
      <OverrideReasonText data-cy="current-override-reason">{overridden.reason}</OverrideReasonText>
      <OverrideReasonBy data-cy="current-override-by">{formatOverriddenBy(overridden)}</OverrideReasonBy>
    </OverrideReasonBox>
  );
};
